<template>
  <div>
    <v-dialog v-model="dialogSubmit" max-width="350">
      <v-card>
        <v-card-title class="headline">Submit to Leaderboard</v-card-title>
        <v-card-text>
          Do you really want to submit to the leaderboard? <br />
          This can't be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogSubmit = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="onSubmit">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card v-for="task in availableTasks" :key="task" class="mb-3">
      <v-card-title>
        {{ taskNameMapping[task] }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="getHeaders()"
        :sort-by.sync="sortby"
        :sort-desc.sync="desc"
        :items="submissions[task]"
        hide-default-footer
        disable-pagination
        class="elevation-1"
        dense
      >
        <template v-slot:item.evaluated="props">
          <router-link
            v-if="props.item.evaluated && !props.item.failed"
            style="padding: 3px 12px 3px 12px; margin: 2px 0px 2px 0px;"
            :to="'/submissions/' + props.item._id"
            class="btn btn-secondary btn-sm"
          >
            <i class="fas fa-file-alt"></i>
          </router-link>

          <i v-if="!props.item.evaluated" class="fas fa-spinner fa-pulse"></i>

          <i
            v-if="props.item.failed"
            class="fas fa-exclamation-circle text-danger"
          ></i>
        </template>

        <template v-slot:item.controls="props">
          <div v-if="props.item.failed" class="text-danger">
            {{ getErrorFromMetaInformation(props.item) }}
          </div>
          <div v-if="props.item.evaluated && !props.item.failed">
            <button
              v-if="!props.item.public"
              class="btn btn-primary btn-sm"
              @click="openDialog(props.item)"
            >
              <i class="fas fa-file-import"></i>
              Submit to Benchmark
            </button>
            <span v-if="props.item.public">Submitted</span>
            <!--            <button-->
            <!--              v-if="props.item.public"-->
            <!--              class="btn btn-secondary btn-sm"-->
            <!--              @click="removeFromLeaderboard(props.item)"-->
            <!--            >-->
            <!--              <i class="fas fa-undo"></i>-->
            <!--              Remove from Benchmark-->
            <!--            </button>-->
          </div>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    "submissions",
    "removeFromLeaderboard",
    "submitToLeaderboard",
    "isSemantic",
    "isUncertain",
    "isDetection",
    "isPanoptic"
  ],

  data() {
    let sortingCriterion;
    if (this.isSemantic)
      sortingCriterion = "results.IoU.IoU";
    if (this.isUncertain)
      sortingCriterion = "results.Average_UIoU.Avg_UIoU";
    if (this.isDetection)
      sortingCriterion = "results.AP.AP";
    if (this.isPanoptic)
      sortingCriterion = "results.PQ.PQ";
    return {
      sortby: sortingCriterion,
      dialogSubmit: false,
      selectedEntry: null,
      desc: true,
      availableTasks: ["all", "fog", "night", "rain", "snow", "normal", "allAdverseAndNormal"],
      taskNameMapping: {
          all: "All Adverse Conditions",
          rain: "Rain",
          snow: "Snow",
          fog: "Fog",
          night: "Night",
          undefined: "undefined",
          normal: "Normal",
          allAdverseAndNormal: "All Adverse and Normal Conditions",
      },
      challenges: {}
    };
  },
  methods: {
    onSubmit() {
      this.submitToLeaderboard(this.selectedEntry);
      this.dialogSubmit = false;
      this.selectedEntry = null;
    },
    openDialog(item) {
      this.selectedEntry = item;
      this.dialogSubmit = true;
    },
    getErrorFromMetaInformation(item) {
      const errorMsg = item?.["meta_information"]?.["error"]?.["msg"];
      return errorMsg ? errorMsg : "Internal Error";
    },
    getHeaders: function() {
      const headers = [
        {
          text: "Name",
          align: "start",
          filterable: true,
          value: "method_name"
        },
        { text: "Created At", value: "created_at" }
      ];
      
      if (this.isSemantic) {
        headers.push({
          text: "IoU",
          align: "start",
          filterable: true,
          value: "results.IoU.IoU"
        });
      }

      if (this.isUncertain) {
        headers.push({
          text: "Avg UIoU",
          align: "start",
          filterable: true,
          value: "results.Average_UIoU.Avg_UIoU"
        });
        headers.push({
          text: "IoU",
          align: "start",
          filterable: true,
          value: "results.IoU.IoU"
        });
      }

      if (this.isDetection) {
        headers.push({
          text: "AP",
          align: "start",
          filterable: true,
          value: "results.AP.AP"
        });
      }

      if (this.isPanoptic) {
        headers.push({
          text: "PQ",
          align: "start",
          filterable: true,
          value: "results.PQ.PQ"
        });
        headers.push({
          text: "PQ things",
          align: "start",
          filterable: true,
          value: "results.PQ.PQ_things"
        });
        headers.push({
          text: "PQ stuff",
          align: "start",
          filterable: true,
          value: "results.PQ.PQ_stuff"
        });
      }

      headers.push({ text: "Results", value: "evaluated" });
      headers.push({
        text: "",
        value: "controls",
        sortable: false,
        align: "end"
      });
      return headers;
    }
  }
};
</script>
